import React from 'react'
import { createNgReactBridgeDirective } from '../../react-bridge'
import { RemoteComponent } from '@contrast-security-inc/design-system-foundations'

export const ProtectRules = React.lazy(
  //@ts-expect-error
  () => import('policyManagement/protect-rules')
)

export const ProtectRuleDrilldown = React.lazy(
  //@ts-expect-error
  () => import('policyManagement/protect-rule-drilldown')
)

export const ProtectRulesDefaults = React.lazy(
  //@ts-expect-error
  () => import('policyManagement/protect-rules-defaults')
)

export const reactMfeProtectRules = createNgReactBridgeDirective(
  'reactMfeProtectRules',
  [],
  () => (
    <RemoteComponent>
      <ProtectRules />
    </RemoteComponent>
  ),
  []
)

export const reactMfeProtectRulesDefaults = createNgReactBridgeDirective(
  'reactMfeProtectRulesDefaults',
  [],
  () => (
    <RemoteComponent>
      <ProtectRulesDefaults />
    </RemoteComponent>
  ),
  []
)

export const reactMfeProtectRuleDrilldown = createNgReactBridgeDirective(
  'reactMfeProtectRuleDrilldown',
  [],
  () => (
    <RemoteComponent>
      <ProtectRuleDrilldown />
    </RemoteComponent>
  ),
  []
)
